// extracted by mini-css-extract-plugin
export default {"img-preview":"AdminNewProduct_img-preview__Km0y-","new":"AdminNewProduct_new__jUOqs","newContainer":"AdminNewProduct_newContainer__GE4rM"};